// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__3F8np","cityName":"Card_cityName__3Ze27","closeButton":"Card_closeButton__3CayY"};